export default "__VITE_ASSET__Bju8vUdc__"